<template>
  <v-app-bar
    dark
  >
    <v-app-bar-nav-icon @click="$root.sidebar = true"></v-app-bar-nav-icon>
    <v-toolbar-title>Admin panel</v-toolbar-title>
  </v-app-bar>
</template>

<script>
export default {

}
</script>

<style>

</style>